/**
 * 
 values: {
    list: [
      {
        href: {
          url: "",
          target: "",
          isCollection: false,
          collection: 0,
        },
        imageUrl: {
          url: "",
          urlMobile: "",
          desktop: {
            width: 0,
            height: 0,
          },
          mobile: {
            width: 0,
            height: 0,
          },
        },
        title: "",
        titleDiscount: "",
        discount: 0,
      },
    ],
    columnDesktop: 3,
    header: "Header",
    alignHeader: "center",
    containerPadding: "0px",
    visibleHeader: true,
  },
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import Toggle from "material-ui/Toggle";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { Box } from "rebass";
import { DivHeaderActions, DivTitle } from "./styled";
import Paper from "material-ui/Paper";
import { Card, CardHeader, CardText } from "material-ui/Card";
import {
  BlockCounter,
  Counter,
  Alignment,
  TextInput,
  DialogDealGroup,
  ProductListInput,
} from "./components";
import { RestApiProductList } from "../../../../restClient";

// const defaultHref = {
//   url: "",
//   target: "",
//   isCollection: false,
//   collection: 0,
// }

class DealGroupView extends Component {
  constructor(props) {
    super(props);
    const {
      containerPadding,
      alignHeader,
      list,
      typeContent,
      listProduct,
      columnDesktop,
      header,
      showPrice,
      showDiscount,
      visibleHeader,
    } = props.data.values;

    this.state = {
      list: list || [],
      columnDesktop: columnDesktop,
      header: header,
      expanded: true,
      expandedList: true,
      typeContent: typeContent,
      alignHeader: alignHeader,
      listProduct: listProduct,
      showPrice: showPrice,
      showDiscount: showDiscount,
      containerPadding: containerPadding,
      visibleHeader: visibleHeader,
    };
  }
  getProductList = () => {
    const { listProduct } = this.state;
    let newValue = [];
    if (Array.isArray(listProduct)) {
      newValue = listProduct;
    }
    let params = newValue.join();

    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then((response) => {
        return response.json();
      })
      .then((items) => {
        if (items && !items.messages) {
          let newItems = [];
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j]);
          }
          const { id } = this.props;
          const productlist = "DealGroupView" + id;
          localStorage.setItem(productlist, JSON.stringify(newItems));
          localStorage.setItem(`DealGroupViewID${id}`, JSON.stringify(params));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };
  handleExpandChange = (expanded, key) => {
    this.setState({ [key]: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.alignHeader = this.state.alignHeader;
    newData.values.list = this.state.list;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.columnDesktop = this.state.columnDesktop;
    newData.values.header = this.state.header;
    newData.values.visibleHeader = this.state.visibleHeader;
    newData.values.listProduct = this.state.listProduct;
    newData.values.showPrice = this.state.showPrice;
    newData.values.showDiscount = this.state.showDiscount;
    newData.values.typeContent = this.state.typeContent;
    this.props.onUpdateData(newData);
  };

  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.alignHeader = this.state.alignHeader;
    newData.values.list = this.state.list;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.columnDesktop = this.state.columnDesktop;
    newData.values.header = this.state.header;
    newData.values.visibleHeader = this.state.visibleHeader;
    newData.values.listProduct = this.state.listProduct;
    newData.values.showPrice = this.state.showPrice;
    newData.values.showDiscount = this.state.showDiscount;
    newData.values.typeContent = this.state.typeContent;
    localStorage.setItem("DealGroupView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const imageContent = JSON.parse(localStorage.getItem("DealGroupView"));
    if (imageContent) {
      const {
        containerPadding,
        alignHeader,
        list,
        columnDesktop,
        header,
        visibleHeader,
        listProduct,
        showDiscount,
        showPrice,
        typeContent,
      } = imageContent;

      this.setState({
        alignHeader: alignHeader,
        list: list,
        containerPadding: containerPadding,
        columnDesktop: columnDesktop,
        header: header,
        visibleHeader: visibleHeader,
        listProduct: listProduct,
        showPrice: showPrice,
        showDiscount: showDiscount,
        typeContent: typeContent,
      });
    }
  };
  onSetValue = (key, value) => {
    this.setState({ ...this.state, [key]: value });
  };
  onChangeTarget = (event, index, value) => {
    this.setState({
      typeContent: value,
    });
  };
  onUpdateProduct = (values) => {
    this.setState({ listProduct: values });
  };
  onTogglePrice = (e, v, k) => {
    this.setState({ [k]: v });
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expandedList}
            onExpandChange={(e) => this.handleExpandChange(e, "expandedList")}
          >
            <CardHeader
              title="List"
              subtitle="Content List Product"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              style={{ overflowY: "scroll", minHeight: 100 }}
              expandable={true}
            >
              <div style={{ padding: 8 }}>
                <Paper style={styles.paperText} zDepth={1}>
                  <DivTitle>Type Content</DivTitle>
                  <SelectField
                    floatingLabelText="Target"
                    onChange={(event, index, value) =>
                      this.onChangeTarget(event, index, value)
                    }
                    value={this.state.typeContent}
                    autoWidth={true}
                    name="typeContent"
                  >
                    <MenuItem value={"custom"} primaryText="Custom" />
                    <MenuItem value={"collection"} primaryText="Collection" />
                  </SelectField>
                </Paper>
                <Paper style={styles.paperText} zDepth={1}>
                  {this.state.typeContent === "collection" && (
                    <div>
                      <DivTitle>Collections</DivTitle>
                      <ProductListInput
                        values={this.state.listProduct}
                        onChangeList={(product) =>
                          this.onUpdateProduct(product)
                        }
                        typePage={this.props.typePage}
                        marketerId={this.props.marketerId}
                      />
                    </div>
                  )}
                  {this.state.typeContent === "custom" && (
                    <DialogDealGroup
                      list={this.state.list}
                      onSetValue={(k, v) => this.onSetValue(k, v)}
                    />
                  )}

                  <Box w={[1]} py={[1]}>
                    <Toggle
                      label="Show Price"
                      style={{ marginBottom: 10 }}
                      toggled={this.state.showPrice}
                      onToggle={(e, v) => this.onTogglePrice(e, v, "showPrice")}
                    />
                  </Box>
                  <Box w={[1]} py={[1]}>
                    <Toggle
                      label="Show Discount"
                      style={{ marginBottom: 10 }}
                      toggled={this.state.showDiscount}
                      onToggle={(e, v) =>
                        this.onTogglePrice(e, v, "showDiscount")
                      }
                    />
                  </Box>
                </Paper>
              </div>
            </CardText>
          </Card>

          <Card
            expanded={this.state.expanded}
            onExpandChange={(e) => this.handleExpandChange(e, "expanded")}
          >
            <CardHeader
              title="General"
              subtitle="Content Image"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              style={{ overflowY: "scroll", height: 500 }}
              expandable={true}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={(containerPadding) =>
                    this.onSetValue("containerPadding", containerPadding)
                  }
                />
              </Paper>

              <Paper style={{ padding: 10 }} zDepth={1}>
                <DivTitle> Column Desktop</DivTitle>
                <Counter
                  isDisabled={false}
                  onSetValue={(value) =>
                    this.onSetValue("columnDesktop", value)
                  }
                  value={this.state.columnDesktop}
                  interval={1}
                  maxValue={10}
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Title Header</DivTitle>
                <TextInput
                  value={this.state.header}
                  onChange={(value) => this.onSetValue("header", value)}
                  title=""
                />
                <div>
                  <Toggle
                    label="Show Header"
                    style={{ marginTop: 10 }}
                    toggled={this.state.visibleHeader}
                    onToggle={(e, v) => this.onSetValue("visibleHeader", v)}
                  />
                </div>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Alignment Header</DivTitle>
                <Alignment
                  value={this.state.alignHeader}
                  onChange={(value) => this.onSetValue("alignHeader", value)}
                  title=""
                />
              </Paper>

              {/* 
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Upload Image</DivTitle>
                <UploadImage
                  type={type}
                  imageUrl={this.state.imageUrl}
                  onUpdateUrl={(value) => this.onUpdateUrl(value)}
                  title="Image"
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <SelectField
                  floatingLabelText="Target"
                  onChange={(event, index, value) =>
                    this.onChangeTarget(event, index, value)
                  }
                  value={valueTarget}
                  autoWidth={true}
                  name="target href"
                >
                  <MenuItem value={"same"} primaryText="Same Page" />
                  <MenuItem value={"_blank"} primaryText="New Page" />
                </SelectField>
                <TextInput
                  value={this.state.href.url}
                  onChange={(value) => this.onUpdateHrefUrl(value)}
                  name="HrefUrl"
                  title="Url"
                  fullWidth={true}
                />
              </Paper> */}
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10,
  },
  headerCard: {
    display: "flex",
    textAlign: "left",
  },
  paperCard: {
    margin: 10,
    overflowY: "auto",
  },
  paperText: {
    padding: 10,
    marginBottom: 10,
  },
  customWidth: {
    width: 150,
  },
  block: {
    maxWidth: 250,
  },
  radioButton: {
    width: 60,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
  },
};

DealGroupView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired,
  typePage: PropTypes.string,
  marketerId: PropTypes.string,
};

DealGroupView.defaultProps = {
  data: {},
  typePage: "",
  marketerId: "0",
};
export default DealGroupView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/DealGroupView.js